export enum Permission {
    Editor = 'editor',
    Admin = 'admin',
}
